import { Autocomplete, Button, Grid, TextField } from "@mui/material";
import React, { useEffect } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import reportStyle from "../DailyReports/DailyReport.module.css";
import { useState } from "react";
import dayjs from "dayjs";
import DailyImg from "../../../images/Daily_report.svg";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { Row, Col } from "react-bootstrap";
import { Route, Routes, useNavigate } from "react-router-dom";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import SecureLS from "secure-ls";
import { encrypt } from "../../../utils/cipher";
import Swal from "sweetalert2";
import Loader from "../../utils/Loader/Loader";

const DailyReport = () => {
  var ls = new SecureLS();
  let initialValues = {
    dailyReportName: "",
    reportFrequency: "daily",
    date: "",
  };

  const navigate = useNavigate();

  const yesterday = dayjs().add(-1, "day");
  const today = dayjs(new Date());
  const yesterdayFormattedDate = yesterday.toISOString().split("T")[0];
  const [values, setValues] = useState(initialValues);
  const [reportName, setReportName] = useState("");
  const [reportDate, setReportDate] = useState(yesterdayFormattedDate);
  const [isLoading, setIsLoading] = useState(false);
  const [reportValue, setReportValue] = useState("");
  const [dailyReports, setDailyReports] = useState(null);
  const token = ls.get("token");
  useEffect(() => {
    console.log("inside useeffect");
    let DR = [];

    let reportPayload = {
      frequency: "daily",
      token: token,
    };
    console.log("get report payload", reportPayload);
    let encryptedPayload = encrypt(reportPayload);

    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/getReportList`, {
        payload: encryptedPayload,
      })
      .then((res) => {
        console.log("res from getreport", res);
        if (res.data.success) {
          res.data.list.map((x, ind) => {
            DR.push({ case: `${ind + 1}`, label: x.reportName });
          });
        }
        setDailyReports(DR);
      })
      .catch((errReport) => {
        console.log("errReport", errReport);
      });
  }, []);

  const handleChange = (event) => {
    console.log(event.target);
    let { name, value } = event.target;
    setValues({ ...values, [name]: value });
  };

  const dailyPayload = {
    reportDetails: {
      reportName: reportName,
      reportDate: reportDate,
    },
    reportCategory: "STATIC",
    token: token,
  };

  console.log("FE DR payload", dailyPayload);
  let encryptedPayload = encrypt(dailyPayload);
  const handleDailyDownload = async () => {
    if (
      dailyPayload?.reportDetails?.reportName == "" ||
      dailyPayload?.reportDetails?.reportDate == ""
    ) {
      Swal.fire({
        title: "Warning",
        text: "Please fill all fields",
        icon: "warning",
      });
    } else {
      setIsLoading(true);
      await axios
        .post(`${process.env.REACT_APP_BACKEND_URL}/createReport`, {
          payload: encryptedPayload,
        })
        .then((res) => {
          console.log("inside weekly create report");
          if (res.data.url) {
            window.open(
              `${process.env.REACT_APP_BACKEND_URL}/reports/downloadfile?link=${res.data.url}`
            );
            setIsLoading(false);
            Swal.fire({
              title: "Success",
              text: "File downloaded successfully",
              icon: "success",
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "File couldn't be Downloaded",
              icon: "error",
            });
            setIsLoading(false);
          }
        })
        .catch((err) => {
          ls.clear();

          console.log("err", err);
          Swal.fire({
            title: "Error",
            text: "Session Expired",
            icon: "error",
          });
          navigate("/");
        });
    }
  };

  return (
    <>
      <div className={reportStyle.Daily}>
        <p style={{ margin: "0 0 0 2rem", fontFamily: "Montserrat" }}>
          Daily Report
        </p>

        <div className={reportStyle.dailyReportsDiv}>
          <Grid
            item
            xs={0}
            sm={0}
            md={6}
            lg={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <img
              className={reportStyle.dailyimg}
              src={DailyImg}
              alt=""
              style={{ margin: "3rem 0rem" }}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            className={reportStyle.dailyReportsContent}
          >
            <Autocomplete
              className={reportStyle.dailyReports}
              id="disable-clearable"
              sx={{
                "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                  fontSize: "1.01rem",
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: "600",
                  textDecoration: "none",
                  paddingLeft: "2px",
                  color: "#1D1C3E",
                },
              }}
              options={dailyReports}
              getOptionLabel={(option) => {
                setReportName(option.label);
                setReportValue(option.value);
                return option.label
              }}
              onChange={(event, selectedOption) => {
                console.log("here in the error", event, selectedOption)
                setReportName(selectedOption?.label);
                setReportValue(selectedOption?.value);
                // console.log("Report name selected---", reportName);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Report"
                  variant="standard"
                />
              )}
            />

            <LocalizationProvider
              // className={dailyReports.dailyCalendar}
              dateAdapter={AdapterDayjs}
            >
              <DemoContainer components={["DatePicker", "DesktopDatePicker"]}>
                <DesktopDatePicker
                  className={reportStyle.dailyDate}
                  disableFuture
                  defaultValue={today}
                  onChange={(date) => {
                    if (date) {
                      console.log("datedate", date);
                      let formattedDate = date
                        .add(-1, "day")
                        .toISOString()
                        .split("T")[0]; // Get YYYY-MM-DD part
                      setReportDate(formattedDate);
                      console.log("Report Date---", formattedDate);
                    }
                  }}
                  format="DD-MM-YYYY"
                  slotProps={{
                    layout: {
                      sx: {
                        ".MuiDateCalendar-root": {
                          color: "#1D1C3E",
                        },
                      },
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>

            <Button
              className={reportStyle.dailyDownload}
              variant="outlined"
              onClick={handleDailyDownload}
              disabled={isLoading}
              sx={{ color: `${isLoading ? "#000 !important" : "#1D1C3E"}` }}
            >
              {isLoading ? "Downloading..." : "Download"}
              {isLoading && <Loader color="#1D1C3E" />}
            </Button>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default DailyReport;
